import React, { useEffect, useState } from "react";
import ModelsManager from "../../components/Models/ModelsManager";
import { getClients } from "../../services/clients";

/**
 * Admin-console model registry: every model, admin-level and per-client.
 */
export const Models = () => {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    let cancelled = false;

    getClients()
      .then((result) => {
        if (cancelled) return;
        const list = Array.isArray(result) ? result : result?.clients ?? [];
        setClients(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        // The registry still works without client names; the raw ids are shown instead.
        if (!cancelled) setClients([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return <ModelsManager scope="admin" clients={clients} />;
};

export default Models;
